import { render, staticRenderFns } from "./DateTextField.vue?vue&type=template&id=20febb4b"
import script from "./DateTextField.vue?vue&type=script&lang=ts"
export * from "./DateTextField.vue?vue&type=script&lang=ts"
import style0 from "./DateTextField.vue?vue&type=style&index=0&id=20febb4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports